/**
 * @desc 绑定应用和接口
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(
  body: defs.appCenter.ApiScopeBindRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/apiScope/bind`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
